import { FlagsmithClientProvider } from '@openfeature/flagsmith-client-provider';
import { OpenFeature } from '@openfeature/web-sdk';
import { reaction } from 'mobx';
import {
    flagsmith_external_proxy_hostname,
    flagsmith_client_side_environment_key,
} from './consts.js';
import { email, user_id } from './userData.js';

if (typeof window !== 'undefined') {
    if (!window.flagsmith_external_proxy_hostname || !window.flagsmith_client_side_environment_key) {
        window.flagsmith_external_proxy_hostname = flagsmith_external_proxy_hostname;
        window.flagsmith_client_side_environment_key = flagsmith_client_side_environment_key;
    }
}

let userContextReactionStarted = false;

function getIdentityTargetingKey() {
    const id = user_id.get();
    const mail = email.get();
    if (id != null && id !== '' && mail) {
        return `${id}:${mail}`;
    }
    return null;
}

function buildOpenFeatureContext(targetingKey) {
    const openFeatureContextOptions = { traits: {} };
    if (targetingKey !== null) {
        openFeatureContextOptions.targetingKey = targetingKey;
    }
    return openFeatureContextOptions;
}

async function applyOpenFeatureContext(targetingKey) {
    await OpenFeature.setContext(buildOpenFeatureContext(targetingKey));
}

export async function initializeFeatureFlags() {
    const flagsmithClientProvider = new FlagsmithClientProvider({
        api: `https://${window.flagsmith_external_proxy_hostname}/api/v1/`,
        environmentID: window.flagsmith_client_side_environment_key,
        cacheFlags: false,
        cacheOptions: {
            skipAPI: false,
        },
    });

    const initialContext = buildOpenFeatureContext(getIdentityTargetingKey());
    await OpenFeature.setProviderAndWait(flagsmithClientProvider, initialContext);

    if (!userContextReactionStarted) {
        userContextReactionStarted = true;
        reaction(
            () => getIdentityTargetingKey(),
            (targetingKey) => {
                void applyOpenFeatureContext(targetingKey);
            },
            { fireImmediately: false }
        );
    }
}

export async function getFlagValue(flagKey, defaultValue = false) {
    const client = await OpenFeature.getClient();
    return client.getBooleanValue(flagKey, defaultValue);
}
